import * as yup from 'yup';
import { addMonths, addYears, subYears } from 'date-fns';
import { normalizeDateValue } from '../utils/helper/normalizeDateValue';

export const filterSchema = yup.object({
  startDate: yup
    .date()
    .transform((value, originalValue) =>
      normalizeDateValue(value, originalValue)
    )
    .typeError('Start date must be a valid date')
    .required('Start date is required')
    .min(new Date(2023, 0, 1), 'Start date cannot be earlier than 2023')
    .max(new Date(), 'Start date cannot be in the future')
    .min(subYears(new Date(), 5), 'Start date must be within the last 5 years'),
  endDate: yup
    .date()
    .transform((value, originalValue) =>
      normalizeDateValue(value, originalValue)
    )
    .typeError('End date must be a valid date')
    .required('End date is required')
    .min(yup.ref('startDate'), 'End date must be greater than start date')
    .max(
      addMonths(new Date(), 3),
      'End date cannot be more than 3 month in the future'
    )
    .test(
      'within-5-years',
      'End date must be within 5 years from start date',
      function (value) {
        const { startDate } = this.parent;
        return value && startDate && value <= addYears(startDate, 5);
      }
    ),
  numberOfCandidates: yup.boolean().required(),
  numberOfAcceptedCandidates: yup.boolean().required(),
  numberOfJobPosting: yup.boolean().required(),
  numberOfRejectedCandidates: yup.boolean().required(),
});

export const reportSchema = filterSchema.shape({
  reportName: yup
    .string()
    .transform((value: string) => value.replace(/\s+/g, ' ').trim())
    .required('Report name is required')
    .min(3, 'Report name must be at least 3 characters')
    .max(50, 'Report name must be at most 50 characters'),
});
